import { useEffect } from 'react';
import { Stack, Typography } from '@mui/material';
import { NoticeBannerStatusEnum } from '~/api/types';
import { useGetNoticeBannersQuery } from '~/api/v2/hooks';
import { InfoIcon, UploadIcon } from '~/icons';
import { RootState, useAppDispatch, useAppSelector } from '~/redux';
import { BannerType, closeBanner } from '~/redux/slices/bannerSlice';
import { AUTOHIDE_DURATION } from './RootNotification';
import { topBannerContainerStyles, topBannerIconStyle } from './styles';

const bannerTypeConfig = {
  [BannerType.FILE_UPLOAD]: {
    backgroundColor: 'importantHighlight.main',
    iconFill: '#C121EB',
  },
  [BannerType.FILE_UPLOADED]: {
    backgroundColor: 'confirmHighlight.main',
    iconFill: '#59A719',
  },
  [BannerType.FILE_ERROR]: {
    backgroundColor: 'errorHighlight.main',
    iconFill: '#E53E3E',
  },
};

const TopBanner = () => {
  const dispatch = useAppDispatch();
  const { type, message, isShown } = useAppSelector((state: RootState) => state.banner);
  const { data: noticeBanner } = useGetNoticeBannersQuery({}, { pollingInterval: 60000 });

  useEffect(() => {
    let bannerTimeout: NodeJS.Timeout;
    if (isShown) {
      if ([BannerType.FILE_UPLOADED, BannerType.FILE_ERROR].includes(type!)) {
        bannerTimeout = setTimeout(() => dispatch(closeBanner()), AUTOHIDE_DURATION);
      }
    }

    return () => clearTimeout(bannerTimeout);
  }, [isShown, type]);

  if (!isShown && !noticeBanner?.message) {
    return null;
  }

  return (
    <>
      {noticeBanner?.message && noticeBanner?.status === NoticeBannerStatusEnum.ACTIVE && (
        <Stack direction="row" spacing={2} bgcolor="cautionHighlight.main" sx={topBannerContainerStyles}>
          <InfoIcon style={topBannerIconStyle} fill="#F7A800" />
          <Typography>{noticeBanner.message}</Typography>
        </Stack>
      )}
      {isShown && type && (
        <Stack
          direction="row"
          spacing={2}
          sx={topBannerContainerStyles}
          bgcolor={bannerTypeConfig[type].backgroundColor}
        >
          <UploadIcon style={topBannerIconStyle} fill={bannerTypeConfig[type].iconFill} />
          <Typography>{message}</Typography>
        </Stack>
      )}
    </>
  );
};

export default TopBanner;
